<template>
  <TopBar />
  <div class="header !flex-shrink-0 items-center justify-between flex"
    :class="{ disabled: appState.currentMenuAction === 'crop' }">
    <div class="logo">
      <div class="flex items-center">
        <img src="@/assets/icons/logo.svg" height="30" alt />
        <span class="font-bold ml-2 text-[18px]">AIdeer</span>
        <span class="ml-3">图片编辑器</span>
      </div>
      <!-- <a-spin v-else-if="logoSrc === 'loading'" :spinning="true"></a-spin>
      <img v-else :src="logoSrc" height="46" alt="logo" @error="logoSrc = ''" /> -->
    </div>
    <!-- <div class="flex-grow flex header-main items-center">
      <a-tooltip placement="bottom" :title="t('common.imageCompare')">
        <IconMirror class="text-5 mr-2"
          :class="{ active: appState.isCompareMode, disabled: appState.editorLoading || appState.loadDataError }"
          @click="toggleCompareMode" />
      </a-tooltip>
      <a-tooltip placement="bottom" :title="multiState.textHidden ? t('common.showWords') : t('common.hideWords')">
        <IconHideText class="text-5 ml-2 mr-2"
          :class="{ active: multiState.textHidden, disabled: appState.editorLoading || appState.loadDataError }"
          @click="toggleHideText" />
      </a-tooltip>
      <a-divider type="vertical" style="height: 20px; background-color: #dadde1" />
      <div class="flex items-center" :class="{ disabled: appState.editorLoading || appState.loadDataError }">
        <span class="icon-wrap ml-2 flex items-center" :class="{ disabled: disabled.undo }"
          @click="() => store.dispatch('record/undo')">
          <a-tooltip placement="bottom" :title="t('common.prevStep')">
            <span class="i-bx:bx-undo icon"></span>
          </a-tooltip>
        </span>
        <span class="icon-wrap flex items-center" :class="{ disabled: disabled.redo }"
          @click="() => store.dispatch('record/redo')">
          <a-tooltip placement="bottom" :title="t('common.nextStep')">
            <span class="i-bx:bx-redo icon"></span>
          </a-tooltip>
        </span>
        <span class="icon-wrap flex items-center" :class="{ disabled: disabled.again }" @click="showAgainModal = true">
          <a-tooltip placement="bottom" :title="t('common.withdrawAll')">
            <span class="i-fluent:history-16-filled icon !text-5"></span>
          </a-tooltip>
        </span>
        <a-divider type="vertical" style="height: 20px; background-color: #dadde1" />
        <Scaler />
        <div class="flex items-center" :class="{ disabled: appState.editorLoading || appState.loadDataError }">
          <a-divider type="vertical" style="height: 20px; background-color: #dadde1" />
          <Download class="flex-shrink-0" />
          <template v-if="appState.WatermarkLayerUrl">
            <a-divider type="vertical" style="height: 20px; background-color: #dadde1" />
            <a-tooltip placement="bottom" :title="t('common.watermarkDesc')">
              <a-switch :checked="appState.HasWatermark" :checked-children="t('common.openWatermark')"
                :un-checked-children="t('common.closeWatermark')"
                @change="store.commit('app/SET_STATE', { HasWatermark: !appState.HasWatermark })" />
            </a-tooltip>
          </template>
</div>
</div>
</div> -->
    <div class="flex items-center gap-2">
      <div class="flex gap-2 items-center">
        <span
          class="bg-[#F1F3F8] text-[#3F4249] right-action-btn inline-block flex items-center justify-center gap-1">前往资料库
        </span>
        <span
          class="bg-[#F1F3F8] text-[#0075FF] right-action-btn inline-block flex items-center justify-center gap-1">保存刷新
          <img src="@/assets/icons/refresh-icon.svg" height="15" alt /></span>
        <span class="bg-[#CFD2DA] text-black right-action-btn inline-block flex items-center justify-center gap-1">全部下载
          <img src="@/assets/icons/download-icon.svg" height="15" alt /></span>
        <span class="bg-[#2B8CFF] text-white right-action-btn inline-block flex items-center justify-center gap-1">选择下载
          <img src="@/assets/icons/download-wh-icon.svg" height="15" alt /></span>
      </div>
      <!-- <Progress class="flex-shrink-0 text-right flex items-center"></Progress> -->
    </div>
    <a-modal v-model:visible="showAgainModal" :cancel-text="t('common.cancel')" :ok-text="t('common.confirm')"
      :title="t('common.withdrawAllDialogTitle')" @ok="doAgain" @cancel="showAgainModal = false">
      <p>{{ t('common.withdrawAllDialogContent') }}</p>
    </a-modal>
  </div>
</template>
<script setup>
import { computed, ref, onMounted } from 'vue';
import Scaler from './Scaler.vue';
import Progress from './Progress.vue';
import { useStore } from 'vuex';
import { sendLog } from '@/utils/sentry';
import { checkUrlExist } from '@/utils';
import { getEditorDataByRequestIdLocal } from '@/utils/ls';
import { useRoute } from 'vue-router';
import IconMirror from '@/components/icons/Mirror.vue';
import IconHideText from '@/components/icons/HideText.vue';
import Download from './Download.vue';
import TopBar from './TopBar.vue';
import { message } from 'ant-design-vue';
import i18n from '@/locales/i18n';
import { LoadingOutlined } from '@ant-design/icons-vue';

const { t } = i18n.global;
const route = useRoute();
const showAgainModal = ref(false);

const store = useStore();

const doAgain = () => {
  showAgainModal.value = false;
  const { requestId } = store.state.multi;
  store.dispatch('user/setCache', {
    requestId,
    v: JSON.stringify(null),
  });
  store.dispatch('app/setGroupState', false);
  store.commit('app/SET_DRAWING_MODE', false);
  store.commit('app/SET_STATE', { isDraw2CancelTransMode: false, isAiInpaintMode: false });
  store.dispatch('app/discardActiveObject');
  store.dispatch('record/doAgain');
  sendLog('doAgain');
};
const appState = computed(() => store.state.app);
const multiState = computed(() => store.state.multi);
const disabled = computed(() => {
  const { requestId } = store.state.multi;
  const { currentIndex, history } = store.state.record;
  return {
    undo: currentIndex <= 0,
    redo: currentIndex >= history.length - 1,
    again: !getEditorDataByRequestIdLocal(requestId) && currentIndex <= 0,
  };
});

const toggleCompareMode = () => store.commit('app/TOGGLE_COMPARE_MODE');
let hide;
const toggleHideText = () => {
  store.commit('multi/SET_HIDE_TEXT', !multiState.value.textHidden);
  hide?.();
  hide = message.success(multiState.value.textHidden ? t('common.hideWordsTip') : t('common.showWordsTip'));
};

// 自定义logo初始化逻辑
const baseLogoUrl = 'https://i.tosoiot.com/logo/';
const logoSrc = ref('loading');
onMounted(async () => {
  let udfLogo = route.query.logo;
  if (!udfLogo) {
    // 如果未设置自定义logo则使用象寄logo
    logoSrc.value = '';
  } else if (udfLogo == 'hidden') {
    // 如果是hidden则隐藏logo
    logoSrc.value = 'hidden';
  } else {
    // 设置了先检查logo对象是否存在，存在则使用否则使用象寄logo
    udfLogo = baseLogoUrl + udfLogo + '.png';
    if (await checkUrlExist(udfLogo)) {
      logoSrc.value = udfLogo;
    } else {
      logoSrc.value = '';
    }
  }
});
</script>
<style lang="less" scoped>
.logo {
  width: 200px;
}

.header {
  height: 56px;
  padding: 0 40px;
  // background: #001529;
  user-select: none;
  border-bottom: 1px solid #eef2f8;
}

.icon-wrap {
  padding: 0px 6px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 22px;
  vertical-align: middle;
  cursor: pointer;
  height: 36px;
  line-height: 36px;
  transition: background-color 0.25s, color 0.25s;
  border-radius: 4px;

  &:hover {
    background: #f1f2f4;
  }

  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }
}

.icon {
  font-size: 24px;
  vertical-align: middle;
}

.add-text {
  font-size: 18px;
  text-align: center;

  .label {
    font-size: 14px;
    color: #999;
    vertical-align: 2px;
  }
}

.redo {
  transform: matrix(-1, 0, 0, 1, 0, 0);
}

.right-action-btn {
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;

  // &:hover {
  //   background: #f1f2f4;
  // }
}
</style>
